export const MC_ENTRY_SOURCE = {
  JOURNEY_ENTRY_SOURCE: 'JOURNEY',
  DATA_EXTENSION: 'DE',
  MANUAL: 'MANUAL',
};

export const BUTTON_ACTIONS_EVENTS = {
  PRIMARY_BUTTON_CLICKED: 'primaryButtonClicked',
  SECONDARY_BUTTON_CLICKED: 'secondaryButtonClicked',
  TEMPLATE_FORM_SUBMITTED: 'templateFormSubmitted',
  TEMPLATE_DELETED: 'templateDeleted',
  MODAL_CLOSED: 'modalClosed',
  TEST_SMS_SENT: 'testSmsSent',
  SEND_PROOFING_INTERSTITIAL: 'sendProofingInterstitial',
  CREATE_WEB_PUSH_CAMPAIGN: 'createWebPushCampaign',
  UPDATE_WEB_PUSH_CAMPAIGN: 'updateWebPushCampaign',
  STOP_WEB_PUSH_CAMPAIGN: 'stopWebPushCampaign',
  SEND_PROOFING_WEB_PUSH: 'sendProofingWebPush',
  SEND_PROOFING_NATIVE_PUSH: 'sendProofingNativePush',
};

export const ACTIVE_MODAL_ORIGIN = {
  CREATE_TEMPLATE: 'CREATE_TEMPLATE',
  UPDATE_TEMPLATE: 'UPDATE_TEMPLATE',
  SEND_PROOFING_SMS: 'SEND_PROOFING_SMS',
  SEND_REAL_VALUES_SMS: 'SEND_REAL_VALUES_SMS',
  SEND_PROOFING_INTERSTITIAL: 'SEND_PROOFING_INTERSTITIAL',
  SEND_PROOFING_WEB_PUSH: 'SEND_PROOFING_WEB_PUSH',
  SEND_PROOFING_NATIVE_PUSH: 'SEND_PROOFING_NATIVE_PUSH',
};

export const ENTRY_DATA_SOURCE = {
  MC_DATA: 'MCData',
  SF_DATA: 'SFData',
  EVENT_DATA: 'EventData',
};

export const CAMPAIGN_TYPE = {
  ONLINE: 'Online',
  RETAIL: 'Retail',
  VLT: 'VLT',
  NEWSLETTER: 'Newsletter',
};

export const ONLINE_PRODUCTS = {
  TZOKER: 'Tzoker',
  KINO: 'Kino',
  LOTTO: 'Lotto',
  PROTO: 'Proto',
  SUPER3: 'Super3',
  SB: 'SB',
  CASINO: 'Casino',
  ALL: 'All',
};

export const SENDER_NAME = {
  OPAP: 'OPAP',
  OPAP_PLAY: 'OPAP PLAY',
  OPAP_STORE: 'OPAP STORE',
  OPAP_RETAIL: 'OPAP RETAIL',
  OPAPREWARDS: 'OPAPREWARDS',
  OPAP_ONLINE: 'OPAPONLINE',
  PS_GR: 'PS.GR',
};

export const WEB_PUSH_PROJECT_CATEGORY = {
  SB: 'sb',
  CASINO: 'casino',
  LOTTERY: 'lottery',
};

export const WEB_PUSH_PROJECT_GAME_ID = {
  SB: 'SB',
  CASINO: 'CASINO',
  LOTTERY: 'LOTTERY',
};

export const CUSTOM_EVENTS = {
  SHOW_CA_TOAST: 'showCaToast',
  MESSAGE_TEMPLATE_PARAMETER_CLICK: 'messageTemplateParameterClick',
};

export const STATE_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
};

export const BUID = {
  UAT: '510001179',
  RETAIL_PROD: '510001039',
  VLT_PROD: '510002563',
  ONLINE_PROD: '510002996',
};

export const APP_MODULES = {
  SMS: 'SMS',
  WEB_PUSH: 'PUSH',
  INTERSTITIAL: 'INTERSTITIAL',
  NATIVE_PUSH: 'NATIVE_PUSH',
};

export const INTERSTITIAL_TEMPLATE_CATEGORY = 'Interstitial';

export const PAM_GAME_ID = {
  PAME_STOIXIMA: 'pame_stoixima',
  CASINO: 'casino',
  OPAP_ONLINE: 'opaponline',
  NEPS: 'neps',
};

export const INTERSTITIAL_TYPE_ID = {
  TEXT_ONLY: 1,
  RICH: 2,
};

export const INTERSTITIAL_EXPIRATION_TYPE = {
  DATE: 'date',
  IN_DAYS: 'inDays',
  IN_HOURS: 'inHours',
};

export const PUSH_RETRY_FOR_PERIOD = {
  WEEKS: 'weeks',
  DAYS: 'days',
  HOURS: 'hours',
  MINUTES: 'minutes',
  SECONDS: 'seconds',
};

export const TEMPLATE_CATEGORY = {
  ONLINE: 'Online',
  RETAIL: 'Retail',
  VLT: 'VLT',
  NEWSLETTER: 'Newsletter',
  WEB_PUSH: 'WebPush',
  INTERSTITIAL: 'Interstitial',
  NATIVE_PUSH: 'NativePush',
};

export const TOAST_TYPE = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  DANGER: 'danger',
};

export const PUSH_RETRY_TYPE = {
  RETRY_FOR: 'retryFor',
  RETRY_UNTIL: 'retryUntil',
};
